export const CONTACT_INFO = {
  instagram: {
    id: '@before_somerise',
    url: 'https://instagram.com/before_somerise',
  },
  email: 'before_somerise@naver.com',
  kakao: 'before_somerise',
  phone: '010-3243-7726',
} as const;

export const BANK_INFO = {
  bankName: '농협은행',
  accountNumber: '352-6546-7726-23',
  accountHolder: '민기태',
};

export const BUSINESS_INFO = {
  location: '전남 나주시 중야2길 6 1F',
  registrationNumber: '482-06-03287',
  representative: '민기태',
} as const;

/** 프로필 등록 오류 시 사용하는 구글 폼 (forms.gle 단축 URL). */
export const PROFILE_FORM_LINK = 'https://forms.gle/hC1bivYo1Ah9BNuc8';